// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"00c47d1c","703":"7867be64","787":"592e7290"}[chunkId] + ".chunk.js";
};